import React from 'react';
import styles from './customAvatarList.module.scss';
import Avatar from 'react-avatar';

export const CustomAvatarList = (props) => {

    let placeholder = `+${props.totalUsers - 5}`;


    return (
        <div className={styles.customAvatarListWrapper}>
            {props.nameArray.length>0 && <Avatar  name={props.nameArray[0]} size="30" round={true}/>}
            {props.nameArray.length>1 && <Avatar style={{'margin-left': '-8px'}} name={props.nameArray[1]} size="30"  round={true}/>}
            {props.nameArray.length>2 && <Avatar style={{'margin-left': '-8px'}} name={props.nameArray[2]} size="30" round={true}/>}
            {props.nameArray.length>3 && <Avatar style={{'margin-left': '-8px'}} name={props.nameArray[3]} size="30" round={true}/>}
            {props.nameArray.length>4 && <Avatar  style={{'margin-left': '-8px'}} name={props.nameArray[4]} size="30" round={true}/>}
            {props.nameArray.length>5 && <Avatar  style={{'margin-left': '-8px'}} value={placeholder} size="35" round={true} color={'#667085'}/>}
        </div>
    )
}
